
import dayjs from 'dayjs'
import { defineComponent } from 'vue'
import AccessTokenMixin from '~/mixins/accessTokenMixin'
import { CreatedAccessToken } from '~/store/accessToken/accessToken'
import { formatDate, parseISODate } from '~/utils/date'

export default defineComponent({
  name: 'CreateTokenModal',
  mixins: [AccessTokenMixin],

  data() {
    return {
      expiry: 7,
      label: '',
      savingToken: false,
      showSuccess: false,
      generatedToken: null as CreatedAccessToken | null,
      expiryOptions: [7, 15, 30, 60, 90, 'Never expire']
    }
  },

  computed: {
    generatedTokenExpiry(): string {
      if (this.generatedToken) {
        return formatDate(parseISODate(this.generatedToken.expiresAt), 'll')
      }
      return ''
    },

    disableAction(): boolean {
      return this.savingToken || this.label === '' || !this.expiry
    },

    expiryDate(): string {
      return formatDate(dayjs(Date.now()).add(this.expiry, 'days').toDate())
    }
  },

  watch: {
    '$route.path': {
      handler() {
        this.closeModal()
      }
    }
  },

  methods: {
    /**
     * wrapper for save token mutation
     *
     * @return {Promise<void>}
     */
    async saveToken(): Promise<void> {
      this.savingToken = true
      this.generatedToken = await this.createUserAccessToken({
        description: this.label,
        expiryDays: isFinite(this.expiry) && this.expiry > 0 ? this.expiry : undefined
      })

      this.$emit('refetch')

      this.savingToken = false
      this.showSuccess = true
    },

    closeModal(): void {
      this.$emit('close')
    }
  }
})
